import { Text } from 'ink';
import ErrorDisplay from '../../../components/ErrorDisplay';
import LoadingText from '../../../components/LoadingText';
import SmokeState from '../utilities/SmokeState';
import BuildError from '../../../components/BuildError';
import TestProgress from './TestProgress';

export default function SmokeTestView({
  commandUsed = '',
  state,
}: {
  commandUsed?: string;
  state: SmokeState;
}) {
  switch (state.state) {
    case 'build-error': {
      const build = requireBuild(state.build, state.state);
      return (
        <BuildError
          build={build}
          description="Can't finish smoke test"
          message={state.error?.message ?? 'Smoke test failed'}
        />
      );
    }

    case 'canceled':
      return <Text>Smoke test canceled.</Text>;

    case 'complete':
      return (
        <Text bold color="greenBright">
          Smoke test passed.
        </Text>
      );

    case 'error':
      return <ErrorDisplay commandUsed={commandUsed} error={state.error} />;

    case 'loading':
      return <LoadingText text="Preparing smoke test" />;

    case 'progress':
      return <TestProgress progress={state.progress} />;

    case 'progress-error':
      const progress = requireProgress(state.progress, state.state);
      const build = requireBuild(state.build, state.state);
      return (
        <>
          <TestProgress progress={progress} />
          <BuildError
            build={build}
            description="Can't finish smoke test"
            message={progress.total.error}
          />
        </>
      );

    default:
      return (
        <ErrorDisplay
          commandUsed={commandUsed}
          error={new Error(`Unknown state ${state}`)}
        />
      );
  }
}

function requireBuild(build: SmokeState['build'], state: SmokeState['state']) {
  if (!build) {
    throw new Error(`Smoke test state "${state}" is missing build data`);
  }

  return build;
}

function requireProgress(
  progress: SmokeState['progress'],
  state: SmokeState['state'],
) {
  if (!progress) {
    throw new Error(`Smoke test state "${state}" is missing progress data`);
  }

  return progress;
}
